import { VariableDisplayOptions } from '../models/APIModels';
import clientUtils from './clientUtils';

// ⛏️ Function/Method :: Configure variableDisplayOptions
export const multilineEnabler = (
  mode: string,
  keyfor: string,
  inputName: any,
  VariableDisplayOptions: VariableDisplayOptions,
  setVal: any,
  setFor?: string // value : multiline  | imgPreview
) => {
  try {
    const keyName = inputName ? clientUtils.uniqueKeyNameGenForVariableDisplayOptions(inputName, keyfor) : '';
    switch (mode) {
      case 'view':
        return VariableDisplayOptions;
      case 'push':
        if (!VariableDisplayOptions.hasOwnProperty(keyName)) {
          VariableDisplayOptions[keyName] = { enableMultiLineText: false, enablePictureViewer: false };
        }
        break;
      case 'pop':
        delete VariableDisplayOptions[keyName];
        break;
      case 'setflag':
        if (setFor === 'multiline') {
            VariableDisplayOptions[keyName].enablePictureViewer = false
          VariableDisplayOptions[keyName].enableMultiLineText = !VariableDisplayOptions[keyName].enableMultiLineText;
        }
        if (setFor === 'imgPreview') {
            VariableDisplayOptions[keyName].enableMultiLineText = false;
            VariableDisplayOptions[keyName].enablePictureViewer = !VariableDisplayOptions[keyName].enablePictureViewer;
          }
        break;
      case 'setflagFalseImgPrev':
        VariableDisplayOptions[keyName].enablePictureViewer = false;
        break;
      case 'setflagFalse':
        VariableDisplayOptions[keyName].enableMultiLineText = false;
        break;
      default:
        console.log('Opps! not a case 👽');
        break;
    }

    console.clear()
    console.log(VariableDisplayOptions);
    setVal('variableDisplayOptions', VariableDisplayOptions);
  } catch (error) {
    console.error(error);
  }
};

 
